import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleIcon from '@mui/icons-material/People';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import EventBusyIcon from '@mui/icons-material/EventBusy';

export const reportTypes = [
  {
    id: 'sales',
    name: 'Sales Report',
    description: 'Sales report for a date range with sales, return, and warranty filters',
    icon: TrendingUpIcon,
    color: '#1976d2'
  },
  {
    id: 'dispense',
    name: 'Dispense Report',
    description: 'Dispense report shows all invoices that have been dispensed for a date range and money received.',
    icon: ShoppingCartCheckoutIcon,
    color: '#19d269'
  },  
  {
    id: 'pending-insurance-claims',
    name: 'Pending Insurance Claims Report',
    description: 'Pending insurance claims report shows all invoices that have been submitted to insurance but not yet reconciled.',
    icon: PaymentIcon,
    color: '#f57c00'
  },
  {
    id: 'inventory',
    name: 'Inventory Report',
    description: 'Current inventory status and low stock alerts',
    icon: InventoryIcon,
    color: '#f57c00'
  },
  // {
  //   id: 'customers',
  //   name: 'Customer Report',
  //   description: 'New customers and customer activity',
  //   icon: PeopleIcon,
  //   color: '#7b1fa2'
  // },
  // {
  //   id: 'individual-customer',
  //   name: 'Individual Customer Report',
  //   description: 'Detailed activity report for a specific customer',
  //   icon: PersonIcon,
  //   color: '#d32f2f'
  // },
  {
    id: 'payment-methods',
    name: 'Payment Methods Report',
    description: 'Payment method usage analysis',
    icon: PaymentIcon,
    color: '#c2185b'
  },
  {
    id: 'payments-received',
    name: 'Payments Received',
    description: 'Line-by-line payments report including refunds and returns',
    icon: PaymentIcon,
    color: '#6a1b9a'
  },
  {
    id: 'insurance-received',
    name: 'Insurance Received',
    description: 'Line-by-line approved insurance amounts received',
    icon: PaymentIcon,
    color: '#2e7d32'
  },
  {
    id: 'due-eye-exam',
    name: 'Due Eye Exam',
    description: 'Eye exams due by recall date with reminder-ready contact details',
    icon: EventAvailableIcon,
    color: '#1565c0'
  },
  {
    id: 'rx-due-soon',
    name: 'Rx Due Soon',
    description: 'Prescriptions expiring soon with reminder-ready contact details',
    icon: AccessAlarmIcon,
    color: '#ef6c00'
  },
  {
    id: 'rx-expired',
    name: 'Rx Expired',
    description: 'Expired prescriptions with reminder-ready contact details',
    icon: EventBusyIcon,
    color: '#c62828'
  }
];
